import React from 'react';
import { StyledInput, StyledDropdown, StyledIcon } from 'components/atoms/tables/smarttables/CommonAssets';
import { Menu } from 'semantic-ui-react';

const Pagination = ({ tableProps }) => {
    const {
        state,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize
    } = tableProps;
    return (
        <React.Fragment>
            <Menu floated={true}>
                <Menu compact style={{ minWidth: '58px', minHeight: '48px' }}>
                    <StyledDropdown
                        style={{ height: '43px', position: 'absolute' }}
                        value={state.pageSize}
                        options={[10, 25, 50].map(pageSize => ({
                            key: pageSize, text: pageSize, value: pageSize
                        }))}
                        onChange={(event, ctx) => {
                            setPageSize(ctx.value);
                        }}
                        item />
                </Menu>
            </Menu>
            {pageOptions.length > 1 &&
                <Menu floated={true} pagination>
                    <Menu.Item as='a' icon onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                        <StyledIcon name='angle double left'/>
                    </Menu.Item>
                    <Menu.Item as='a' icon onClick={() => previousPage()} disabled={!canPreviousPage}>
                        <StyledIcon name='angle left'/>
                    </Menu.Item>
                    <Menu.Item>
                        <StyledInput
                            label={`of ${pageOptions.length}`}
                            labelPosition='right'
                            type='number'
                            value={state.pageIndex + 1}
                            onChange={(event, ctx) => {
                                const currentPage = ctx.value ? Number(ctx.value) - 1 : 0;
                                gotoPage(currentPage);
                            }}
                        />
                    </Menu.Item>
                    <Menu.Item as='a' icon onClick={() => nextPage()} disabled={!canNextPage}>
                        <StyledIcon name='angle right'/>
                    </Menu.Item>
                    <Menu.Item as='a' icon onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                        <StyledIcon name='angle double right'/>
                    </Menu.Item>
                </Menu>
            }
        </React.Fragment>
    );
};
export default Pagination;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/tablePlugins/Pagination.js